module.exports = __webpack_public_path__ + "static/media/check.5883302e.svg";